import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function assertNever(x: never): never {
  throw new Error(`Unexpected value: ${String(x)}`)
}

export function pluralize(n: number, one: string, many: string) {
  return `${n} ${n === 1 ? one : many}`
}
